import React from 'react';
import classNames from 'classnames';
import InfoTooltip from 'components/shared/InfoTooltip';

class TabSection extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
    };
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  handleTabClick(tabIndex) {
    if (tabIndex === this.state.activeTabIndex) return;
    this.setState({ activeTabIndex: tabIndex });
  }

  // Encapsulate <TabSection /> component API as props for <TabSectionTab /> children
  renderChildrenWithTabsApiAsProps() {
    return React.Children.map(this.props.children, (child, index) =>
      React.cloneElement(child, {
        onClick: this.handleTabClick,
        tabIndex: index,
        isActive: index === this.state.activeTabIndex,
      }),
    );
  }

  renderActiveTabContent() {
    const { children } = this.props;
    const { activeTabIndex } = this.state;
    return children[activeTabIndex] && children[activeTabIndex].props.children;
  }

  render() {
    const { className, title, subtitle, tooltip } = this.props;
    return (
      <div className={classNames('TabSection', className)}>
        <div className="TabSection-header">
          <h3 className="DataCard-title">
            {title}
            {tooltip && <InfoTooltip tooltip={tooltip} className="ml-4" />}
            {subtitle && <span className="DataCard-subtitle">{subtitle}</span>}
          </h3>
          <ul className="TabSection-tabsList">
            {this.renderChildrenWithTabsApiAsProps()}
          </ul>
        </div>
        <div key={this.state.activeTabIndex}>
          {this.renderActiveTabContent()}
        </div>
      </div>
    );
  }
}

export default TabSection;
